
<template>
    <div class="login-div">
	   <!-- echarts -->
      
      <div class="echartsCon">
          <div class="title"> {{$t("loginStatistics.echartsTitle")}}<span>{{indexData.signIn30}}</span></div>
          <div id="main"></div>
      </div>

      <!-- 搜索 -->
       <div class="search-div flexC">
            <div class="search-div-item flexC">
              <div class="labelText">{{$t("loginStatistics.titleName.Phone")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.phoneNumber" ></Input>
            </div>


            <div class="search-div-item flexC">
              <div class="labelText">{{$t("loginStatistics.titleName.Email")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.emailAddress" ></Input>
            </div>

            <div class="search-div-item flexC">
              <div class="labelText">{{$t("loginStatistics.LoginId")}}</div>
               <!-- <Input type="number" class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.loginId" ></Input> -->
               <InputNumber class="input-div" :min="1" :precision='0'  :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.loginId" ></InputNumber>
            </div>

            <div class="search-div-item flexC">
              <div class="labelText">{{$t("loginStatistics.OperationalSystem")}}</div>
                <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.os" >
                    <Option v-for="(item, index) in searchObjArr.type" :value="item.id" :key="index">{{item['val']}}</Option>
                </Select>
            </div>
             <div class="search-div-item flexC">

                <Button type="info" @click="searchItem"  icon="ios-search" style="marginTop:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
             </div>
         
        </div>

        <!-- 表格 -->
        <div class="tableCon">
           <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" :loading="loading" ref="selection" @on-selection-change="selectChange" ></Table>
           <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
        </div>
         
	 
	   
    </div >
    
</template>

<script>
import common from "@/common/common.js";
import moment from "moment";
import timerJs from "@/common/time.js"
import { mapState } from 'vuex'

export default {
  name: "loginStatistics",
  components: {
  },
  data() {
    return {
          loading: true,
          type:1,//弹框打开类型 1添加 2编辑
          tableList:{//表格组
              hasSelectData:{},//已选中的行的数据
              tableData: []//表格数据
          },
          indexData:{
              signIn30:''
          },
          chartData:{//图表数据
              dataList:[],
              monthList:[]
          },
          page:{//分页排序
              total:0,//总条数
              pageSize:10,//每页条数
              current:1,//当前页
              key:'id',
              order:'desc'
          },
          searchObjArr:{
              type:[
                 {id: 1,val:'android'},
                 {id: 2,val:'ios'}
               ],
          },
          searchObj:{
              loginId:null,
              emailAddress:"",
              os:"",
              phoneNumber:""
          },
          
         
	};
  },
  computed:{
        ...mapState(['local','selectId']),
        titleName(){
            return [
                  {
                      title: this.$t('loginStatistics.titleName.Login_id'),
                      key: 'id',
                      sortable: true,
                      minWidth: 160
                  },
                  {
                      title: this.$t('loginStatistics.titleName.Login_time'),
                      key: 'loginTime',
                      minWidth: 170,
                      render:(h, params)=>{
                          let stext = moment(params.row.loginTime*1).format('YYYY-MM-DD HH:mm:ss')
                           return h('div',stext || '')
                      }
                  },
                  {
                      title: this.$t('loginStatistics.titleName.Email'),
                      key: 'emailAddress',
                      sortable: true,
                      minWidth: 260
                  },
                  {
                      title: this.$t('loginStatistics.titleName.Phone'),
                      key: 'phoneNumber',
                      minWidth: 150
                  },
                  {
                      title: this.$t('loginStatistics.titleName.os'),
                      key: 'os',
                      minWidth: 180,
                      render:(h, params)=>{
                           let obj = {'1':'android','2':'ios'}
                           let stext = obj[params.row.os]
                           return h('div',stext || '')
                      }
                  },
                  {
                      title: this.$t('loginStatistics.titleName.App'),
                      key: 'appVersion',
                      minWidth: 160
                  },
                  {
                      title: this.$t('loginStatistics.titleName.Location'),
                      key: 'loginAddress',
                      minWidth: 180
                  }
            ]
          }
  },
  created() {

      this.getData();
      this.getTopData()
      this.getchartData()
  },
  watch: {
   },
  mounted(){
  },
  methods: { 
        getTopData(){//汇总数据

            let myDate  = new Date();
           
			let myflag = myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate()+" 00:00:00";    

            let myDate1  = new Date(myDate.getTime()-60*60*24*1000*31);
            let myflag2  = myDate1.getFullYear()+'-'+(myDate1.getMonth()+1)+'-'+myDate1.getDate()+" 00:00:00"; 

            let dataobj = {
				    params:{
				    	startDate:(new Date(myflag2)).getTime(),
				    	endDate:(new Date(myflag)).getTime()-1000,
                        dealerId:this.selectId
				    }
			    }
            this.axios.post(this.config.urlArray.logCount, dataobj.params).then(result => {
	
              this.indexData.signIn30 = result.data.data
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })
        
        },
        getchartData(){//图表数据
            this.chartData.monthList = timerJs.getOldMonth();
            this.axios.post(this.config.urlArray.logChart, this.chartData.monthList).then(result => {
		      common.ajaxMsg(result.data)
              this.chartData.dataList = result.data.data
              this.initEcharts()
		    }).catch(err => {
		      common.msg('error', err, () => {})
		    })

        },

	    initEcharts(){
			 let myEchart = this.$echarts.init(document.getElementById("main"));
             let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                        feature: {
                            dataView: {show: false, readOnly: false},
                            magicType: {show: false, type: ['bar']},
                            restore: {show: false},
                            saveAsImage: {show: false}
                        }
                    },
					color:['#91CC75','#FAC244'], //关键加上这句话，legend的颜色和折线的自定义颜色就一致了
                    legend: {
                        data: ['个数', '个数']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.chartData.monthList,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [
                   
                        {
                            name: this.local=='en-US'?'Login':'登录用户数',
                            type: 'bar',
                            data:  this.chartData.dataList,
							itemStyle: {
                                normal: {
                                  color: function (params) {
                                    //自定义颜色
                                    var colorList = ['#91CC75','#FAC244'];
                                    return colorList[0]
                                  }
                                }
                            }
                        }
                    ]
             };
             myEchart.setOption(option);

		},
        searchItem(){ //搜索
            this.loading = true
            this.getData()
        },
        getData() {//获取数据
            let getData = {
                params: {
                    page: this.page.current,
                    limit: this.page.pageSize,
                    sortfield: this.page.key,
                    ascDesc: this.page.order,
                    dealerId:this.selectId
                }
            }
           
            Object.assign(getData.params,this.searchObj)


            this.axios.post(this.config.urlArray.logsList, getData.params).then((result) => {
                common.ajaxMsg(result.data,false,()=>{

                    let resData = result.data.data.loginList
                    //处理数组
                    this.tableList.tableData  = resData
                    this.page.total = result.data.data.meta.count
                    this.loading = false
                });
            }).catch((err) => {
                // common.msg('error',err,()=>{})
            });
        },
        sortCustom(data) {//自定义排序
            this.page.key = data.key
            this.page.order = data.order
            this.getData()
        },
        
        selectChange(res) { //控制编辑和删除按钮的可用状态
            this.selectChangeData = res
            if(res.length == 1){
                this.buttonList.editDisabled = this.buttonList.delDisabled = false
                this.tableList.hasSelectData = res[0]
            }else{
                this.buttonList.editDisabled = this.buttonList.delDisabled = true
                this.tableList.hasSelectData = {}
            }
        },
        changePage(nowpage) {//切换分页
            this.page.current = nowpage;
            this.getData();
        },
        changeSize(nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        },
        clearbtnStatus() { //删除后清空编辑数据 与按钮状态
            this.buttonList.delDisabled = true
            this.buttonList.editDisabled = true
            this.tableList.hasSelectData = {}
        },
    
  }
};
</script>
 <style scoped lang="less">
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }
 .echartsCon{
    background: #fff;
    margin: 40px 40px;
    border-radius: 14px;
    padding: 20px 40px;
     #main {
       // width: 100%;
   	   flex:1;
       height:400px;
       margin: auto;
       margin-top: 30px
     }
     .title{
         text-align: center;
         height: 17px;
         font-size: 14px;
         font-family: Source Han Sans SC;
         font-weight: 400;
         color: #3A464E;
         span{
             font-weight: bold;
             font-size: 20px;
             margin-left: 4px;
         }
     }

 }

 .search-div{
     flex-wrap: wrap;
     background-color: #fff;
     padding: 34px 40px ;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }

      /deep/  .ivu-input-number-input-wrap{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number-handler{
         height:22px;
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-up-inner{
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-down-inner{
         line-height:22px;
     }


      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
          height: 44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
          height:44px;
         line-height: 44px;
     }
 }

 .tableCon{
     background-color: #fff;
     padding: 34px 40px 1px 34px;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
 }

</style>
